var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',_vm._l((_vm.crumbs),function(crumb,x){return _c('li',{key:x,class:crumb.class},[_c('router-link',{attrs:{"to":{path:crumb.href, params:{stepNumber : crumb.step}}}},[_vm._v(_vm._s(crumb.text))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }